import { format } from "date-fns";
import { signal } from "@preact/signals-react";
import { es } from "date-fns/locale";

import { CalendarIcon } from "components/Icons";
import Calendar from "componentsv2/widgets/Calendar";
import { cn } from "tools/ui";

const baseCard =
  "h-16 py-3 shadow-sm rounded-md cursor-pointer justify-center w-24 active:scale-95 active:shadow-xl bg-sky-950 text-white";
const cardDate = "flex items-center -space-y-2";
const cardNoDate = "p-2 items-center text-center";
const styleMonth = "text-xs font-semibold uppercase text-yellow-300";
const styleDay = "text-xs text-white";

const showPop = signal(false);
const selected = signal(null);

function DateCard({ onChange, name }) {
  function onClick() {
    showPop.value = true;
  }

  function onChangeDate(_date) {
    selected.value = _date;
    onChange(name, _date);
  }

  let dateShow = null;
  if (selected.value) {
    const fmtDate = format(selected.value, "dd");
    const fmtMonth = format(selected.value, "MMM", { locale: es });
    const fmtWeekday = format(selected.value, "EEE", { locale: es });
    dateShow = (
      <button
        type="button"
        data={selected.value}
        className={cn(baseCard, cardDate)}
        onClick={onClick}
      >
        <span className="text-3xl font-semibold my-auto">{fmtDate}</span>
        <div className="grid pl-2">
          <span className={styleMonth}>{fmtMonth}</span>
          <span className={styleDay}>{fmtWeekday}</span>
        </div>
      </button>
    );
  } else {
    dateShow = (
      <button
        type="button"
        data={selected.value}
        className={cn(baseCard, cardNoDate)}
        onClick={onClick}
      >
        <div className="flex flex-col justify-end">
          <CalendarIcon className="mt-auto mx-auto w-5 h-5 fill-current text-white" />
          <p className="text-xs mt-1">Desde</p>
        </div>
      </button>
    );
  }
  return (
    <div id="date-card">
      {dateShow}
      <Calendar value={selected.value} onSelect={onChangeDate} show={showPop} />
    </div>
  );
}

export default DateCard;
